import { Injectable } from "@angular/core";
import {
  ChangePasswordPayload,
  ChangeSecretAnswerPayload,
  CpdPdfPayload,
  ELearningAgent,
  ELearningLOV,
  FilteredAgentPayload,
  Profile,
  SearchedELearning,
  SearchELearningPayload,
  UpdateContactPayload,
} from "@shared/interfaces/profile.model";
import { Observable } from "rxjs";
import { HttpHelperService } from "src/app/shared/services/http-helper.service";

@Injectable()
export class ProfileService {
  constructor(private readonly httpHelperService: HttpHelperService) {}

  public getProfileDetails(userId: string): Observable<Profile> {
    return this.httpHelperService.get(`/users/profile/detail?userId=${userId}`);
  }

  public getELearningLOV(userId: string): Observable<ELearningLOV> {
    return this.httpHelperService.get(`/users/elearning/lov?userId=${userId}`);
  }
  public searchELearning(
    payload: SearchELearningPayload,
  ): Observable<SearchedELearning> {
    return this.httpHelperService.get(
      `/users/elearning/list?agentCode=${payload.agentCode}&trainingYear=${payload.year}&userId=${payload.userId}`,
    );
  }

  public changePassword(body: ChangePasswordPayload) {
    // TODO: Switch to the cloud API once the change-password endpoint is ready.
    return this.httpHelperService.postWithOptions("/user/password/save", body, {
      baseUrl: this.httpHelperService.resolveAlphaSatBaseUrl(),
    });
  }

  public updateProfileDetails(
    body: UpdateContactPayload | ChangeSecretAnswerPayload,
  ) {
    return this.httpHelperService.post("/users/profile/save", body);
  }

  public downloadProfileCpdTraining(
    payload: CpdPdfPayload,
  ): Observable<string> {
    const cpdDeatils = payload.isAdmin
      ? "CDPTrainingSummary"
      : "CDPTrainingDetail";
    return this.httpHelperService.getURL(
      `/users/report/generate/pdf/${cpdDeatils}?branchCode=${payload.branchCode}&agentCode=${payload.agentCode}&trainingYear=${payload.trainingYear}&shortfall=${payload.shortfall}`,
    );
  }

  public getFilteredAgentList(
    payload: FilteredAgentPayload,
  ): Observable<{ agentList: ELearningAgent[] }> {
    return this.httpHelperService.post("/users/elearning/agents", payload);
  }
}
